(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["seo-toc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('seo-table-of-contents')) {
    customElements.define(
      'seo-table-of-contents',
      class extends HTMLElement {
        connectedCallback() {
          window.requestAnimationFrame(() => this.build());
        }

        build() {
          const article = this.closest('.seo-landing');
          const list = this.querySelector('[data-seo-toc-list]');
          if (!article || !list) return;

          const headings = Array.from(article.querySelectorAll('[data-seo-toc-heading="true"][id]'));
          list.replaceChildren();

          if (!headings.length) {
            this.hidden = true;
            return;
          }

          this.hidden = false;
          headings.forEach((heading) => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            const level = heading.tagName.toLowerCase();

            item.className = 'seo-toc__item seo-toc__item--' + level;
            link.href = '#' + encodeURIComponent(heading.id);
            link.textContent = heading.textContent.trim();
            link.addEventListener('click', (event) => {
              event.preventDefault();
              const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              heading.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
              history.pushState(null, '', '#' + encodeURIComponent(heading.id));
            });

            item.appendChild(link);
            list.appendChild(item);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
